import { render, staticRenderFns } from "./PricingAnalytics.vue?vue&type=template&id=d0136230&scoped=true"
import script from "./PricingAnalytics.vue?vue&type=script&lang=js"
export * from "./PricingAnalytics.vue?vue&type=script&lang=js"
import style0 from "./PricingAnalytics.vue?vue&type=style&index=0&id=d0136230&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0136230",
  null
  
)

export default component.exports